module.exports = __webpack_public_path__ + "static/media/Asset 3.6a17bb22.svg";